import {
  CreateNewStep6Body,
  StepToReturnNewStep6Enum,
} from "../../../types/cto/step6";
import { MOCK_LONG_TEXT } from "../genericMocks";

export const dataNewStep6Body: CreateNewStep6Body = {
  closure_review_comments: MOCK_LONG_TEXT,
  should_proceed_for_closure: true,
  step_to_return: StepToReturnNewStep6Enum.STEP_5,
  draft: false,
};
